import { ITableFilterInputProps, ObjectUtils } from 'modules';
import { IInputSelectOption } from 'modules/types';
import React, { FC } from 'react';
import Select from 'react-select';
const SelectElement = Select as any;
interface ITableFilterInputSelectProps extends ITableFilterInputProps {
  options: IInputSelectOption[];
  isClearable?: boolean;
  isSearchable?: boolean;
}

export const TableFilterInputSelect: FC<ITableFilterInputSelectProps> = (
  props,
) => {
  const key = props.paramKey;

  return (
    <SelectElement
      options={props.options.filter((v) => v.value !== props?.value)}
      className='TableFilterInputSelect'
      classNamePrefix='TableFilterInputSelect'
      placeholder='-- Select --'
      onChange={(option: any) => {
        props.onChange({ [key]: ObjectUtils.getIn(option, 'value', '') });
      }}
      value={props?.options?.find((v) => v?.value === props?.value)}
      defaultValue={props?.options?.find(
        (v) => v?.value === props?.params[key],
      )}
      isClearable={props.isClearable}
      isSearchable={props?.isSearchable ?? false}
    />
  );
};

TableFilterInputSelect.defaultProps = {
  isClearable: true,
};
